// @ts-check

import React, { useState } from 'react';
import { number, object } from 'prop-types';
import assignAddressLabel from '../libs/assignAddressLable';
import Grid from '@mui/material/Grid';
import ProfileTextField from './ProfileTextField';
import ProfileMap from './ProfileMap';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import LocationOnIcon from '@mui/icons-material/LocationOn';

/**
 * @component ProfileAddress
 * @param {Object} props
 * @param {number} props.index
 * @param {ProfileAddress} props.address
 * @returns {JSX.Element}
 */
function ProfileAddress({ index, address }) {
	const [openMap, setOpenMap] = useState(false);

	const onOpenMap = () => setOpenMap(!openMap);

	return (
		<>
			<Grid container spacing={2} justifyContent="space-between" alignItems="center">
				<Grid item lg={6.5} xs={12}>
					<ProfileTextField label={assignAddressLabel(index)} value={address.line1} />
				</Grid>
				<Grid item lg={1.25} xs={12}>
					<ProfileTextField label="City" value={address.city} />
				</Grid>
				<Grid item lg={1.25} xs={12}>
					<ProfileTextField label="Province" value={address.province} />
				</Grid>
				<Grid item lg={1.25} xs={12}>
					<ProfileTextField label="Country" value={address.country} />
				</Grid>
				<Grid item lg={1.25} xs={12}>
					<ProfileTextField label="Postal Code" value={address.postal_code} />
				</Grid>
				<Grid item lg={0.5} xs={12}>
					<Tooltip arrow title="View location">
						<IconButton onClick={onOpenMap}>
							<LocationOnIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				</Grid>
			</Grid>
			<ProfileMap
				open={openMap}
				coordinate={{ lat: String(address.lat), lng: String(address.lng) }}
				onClose={onOpenMap}
			/>
		</>
	);
}

ProfileAddress.propTypes = { index: number, address: object };

export default ProfileAddress;
